enum ActivityCacheKeys {
  ActivityDraft = "activity-draft",
  ActivityFields = "activity-fields",
  ActivityHasDraft = "activity-has-draft",
  ActivityHistory = "activity-history",
  ActivityList = "activity-list",
  ActivityArchivedList = "activity-archived-list",
  ActivityDraftList = "activity-draft-list",
  SingleActivity = "single-activity",
  UsedPaths = "activity-used-paths",
}

enum ToolsCacheKeys {
  ToolList = "tool-list",
  ToolDraftList = "tool-drafts-list",
}

enum DocumentsCacheKeys {
  DocumentList = "document-list",
  DocumentArchivedList = "document-archived-list",
  DocumentDraftList = "document-draft-list",
}

enum LinksCacheKeys {
  LinkList = "link-list",
  LinkArchivedList = "link-archived-list",
  LinkDraftList = "link-draft-list",
}

enum ImageCacheKeys {
  ImageList = "image-list",
  ImageArchivedList = "image-archived-list",
  SingleImage = "single-image",
}

export const CacheKeys = {
  Activity: ActivityCacheKeys,
  Tool: ToolsCacheKeys,
  Document: DocumentsCacheKeys,
  Link: LinksCacheKeys,
  Image: ImageCacheKeys,
} as const;
